<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات رژیم"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        autocomplete="off"
                      />
                    </b-form-group>

                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="ActivationType"
                    >
                      <v-select
                        v-model="Form.ActivationType"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="ActivationType"
                        :clearable="false"
                        :options="enums('ActivationType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="متد رژیم"
                      label-for="DietMethod"
                    >
                      <v-select
                        v-model="Form.DietMethod"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="DietMethod"
                        :clearable="false"
                        :options="enums('DietMethod')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="نوع"
                      label-for="DietType"
                    >
                      <v-select
                        v-model="Form.DietType"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="DietType"
                        :clearable="false"
                        :options="enums('DietType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-row class="mt-1">
                      <b-col md="3">
                        <b-form-group
                          label="بیماری"
                        />
                      </b-col>

                      <b-col md="7">
                        <b-form-group
                          label="توضیحات"
                        />
                      </b-col>
                    </b-row>
                    <b-row
                      v-for="(item, index) in Form.DietSickness"
                      :id="item"
                      :key="index"
                      ref="DietSickness"
                      class="mb-1"
                    >

                      <b-col md="3">
                        <b-form-group>
                          <z-sickness
                            v-model="item.Id"
                            :unselectable="Form.DietSickness.map(x => x.Id)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="7">
                        <b-form-group>
                          <b-form-input
                            v-model="item.Description"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: center;"
                      >
                        <template v-if="DietSicknessRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeDietSickness(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelDietSickness"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmDietSickness"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="mb-1"
                      variant="gradient-info"
                      @click="addDietSickness"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-row class="mt-1">
                      <b-col md="4">
                        <b-form-group
                          label="وعده"
                        />
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                          label="درصد"
                        />
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                            label="ترتیب"
                        />
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                            label="ترتیب در ماه رمضان"
                        />
                      </b-col>
                    </b-row>

                      <b-row
                        v-for="(item, index) in Form.DietFoodMeal"
                        :key="index"
                        tag="li"
                        class="mb-1"
                      >

                        <b-col md="4">
                          <b-form-group>
                            <z-food-meal
                              v-model="item.Id"
                              :unselectable="Form.DietFoodMeal.map(x => x.Id)"
                              :multiple="false"
                              class="w-100"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group>
                            <b-form-input
                              v-model="item.Percent"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group>
                            <b-form-input
                                v-model="item.Sort"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group>
                            <b-form-input
                                v-model="item.RamezanSort"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col
                          md="2"
                          class="mb-1"
                          style="display: flex; align-items: center;"
                        >
                          <template v-if="DietFoodMealRemoveId !== index">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="btn-icon rounded-circle"
                              @click="removeDietFoodMeal(index)"
                            >
                              <feather-icon
                                icon="TrashIcon"
                              />
                            </b-button>
                          </template>
                          <template
                            v-else
                            style="display: flex;"
                          >
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle"
                              variant="outline-primary"
                              @click="cancelDietFoodMeal"
                            >
                              <feather-icon icon="XIcon" />
                            </b-button>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle ml-1"
                              variant="outline-primary"
                              @click="confirmDietFoodMeal"
                            >
                              <feather-icon icon="CheckIcon" />
                            </b-button>
                          </template>
                        </b-col>
                      </b-row>

                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="mb-1"
                      variant="gradient-info"
                      @click="addDietFoodMeal"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZSickness from '@/tools/sickness.vue'
import ZFoodMeal from '@/tools/foodmeal.vue'

export default {
  name: 'DietDetails',
  components: {
    ZSickness,
    ZFoodMeal,
  },
  data() {
    return {
      test: null,
      Form: {
        Id: null,
        Title: null,
        ActivationType: 1,
        DietMethod: 0,
        DietType: 0,
        DietFoodMeal: [],
        DietSickness: [],
      },
      DietFoodMealRemoveId: null,
      DietSicknessRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addDietSickness()
      this.addDietFoodMeal()
    }
  },
  methods: {
    save() {
      let url = this.$api.diet.add
      if (this.$route.params.id) {
        url = this.$api.diet.update
      }

      const form = JSON.parse(JSON.stringify(this.Form))

      form.DietFoodMeal = form.DietFoodMeal.filter(x => x.Id)
      form.DietSickness = form.DietSickness.filter(x => x.Id)

      this.loading = true
      this.$http.post(
        url, form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.diet.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          if (this.Form.DietSickness){
            this.addDietSickness()
          }

          if (this.Form.DietFoodMeal.length === 0){
            this.addDietFoodMeal()
          }

        })
    },
    addDietSickness() {
      this.Form.DietSickness.push({ Id: null, Description: null })
    },
    addDietFoodMeal() {
      this.Form.DietFoodMeal.push({ Id: null, Percent: 0, Sort: 0, RamezanSort: 0 })
    },
    removeDietFoodMeal(index) {
      this.DietFoodMealRemoveId = index
    },
    confirmDietFoodMeal() {
      this.Form.DietFoodMeal.splice(this.DietFoodMealRemoveId, 1)
      this.DietFoodMealRemoveId = null
    },
    cancelDietFoodMeal() {
      this.DietFoodMealRemoveId = null
    },
    removeDietSickness(index) {
      this.DietSicknessRemoveId = index
    },
    confirmDietSickness() {
      this.Form.DietSickness.splice(this.DietSicknessRemoveId, 1)
      this.DietSicknessRemoveId = null
    },
    cancelDietSickness() {
      this.DietSicknessRemoveId = null
    },
  },
}
</script>
